import {createAction} from '@reduxjs/toolkit'
import {
  CacIdpAdditionalControls,
  CloudAppResponseType,
  PolicyNamePayloadType,
  CloudAppPayloadType,
} from 'interfaces/Policy'

import {CacGlobalSettingsAppId} from './cloudApp.constant'

export const getCloudApp = createAction<PolicyNamePayloadType>('getCloudApp')
export const getCloudAppSuccess =
  createAction<CloudAppResponseType>('getCloudAppSuccess')
export const getCloudAppFailure = createAction<string>('getCloudAppFailure')

export interface UpdateCloudAppPayload {
  request: CloudAppPayloadType
  saved: CloudAppResponseType
}

export const updateCloudApp =
  createAction<UpdateCloudAppPayload>('updateCloudApp')
export interface UpdateCloudAppSuccessPayload {
  message: string
  policyName: string
  saved: CloudAppResponseType
}

export const updateCloudAppSuccess = createAction<UpdateCloudAppSuccessPayload>(
  'updateCloudAppSuccess',
)
export interface UpdateCloudAppFailurePayload {
  message: string
  policyName: string
}
export const updateCloudAppFailure = createAction<UpdateCloudAppFailurePayload>(
  'updateCloudAppFailure',
)

export const getBasePolicyCloudApp = createAction('getBasePolicyCloudApp')
export const getBasePolicyCloudAppSuccess = createAction<CloudAppResponseType>(
  'getBasePolicyCloudAppSuccess',
)
export const getBasePolicyCloudAppFailure = createAction<string>(
  'getBasePolicyCloudAppFailure',
)

export const changeCloudApp =
  createAction<CloudAppResponseType>('changeCloudApp')
export interface UpdateCacAdditionalControlsPayload {
  appId: CacGlobalSettingsAppId
  changes: Partial<CacIdpAdditionalControls>
}
export const updateCacAdditionalControls =
  createAction<UpdateCacAdditionalControlsPayload>(
    'updateCacAdditionalControls',
  )
export const removeCloudAppSnapshot = createAction('removeCloudAppSnapshot')
